module.exports = __webpack_public_path__ + "static/img/fream-queue.75624c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fream-queue.png
// module id = W7Y6
// module chunks = 3